import { motion } from "framer-motion";
import badge1 from "../assets/AchievementImg/badge3.png";
import badge2 from "../assets/AchievementImg/badge2.png";


import logoImg from "../assets/Best_IT_Tranning_Near_Me.png"; // Adjust the path as necessary


const badges = [
  { src: badge1, alt: "Clutch Chicago" },
  { src: badge2, alt: "Clutch Global Fall" },
  

];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

export default function AchievementsPage() {
  return (
    <section className="bg-white text-center px-4 py-20 sm:px-10 md:px-20">
      <motion.div
        className="flex flex-col items-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
      >

        <h2 className="text-3xl sm:text-4xl font-bold text-orange-500 mb-2">
          Proudly Honored for Our Achievements
        </h2>
        <div className="h-1 w-12 bg-blue-900 rounded-full mb-6"></div>

        <p className="text-gray-700 mb-6 max-w-2xl">
          Named a top 250 Managed Service Provider in Noida.
        </p>

        <img
          src={logoImg} // use local image if needed
          alt="MSP 500"
          className="w-[180px] mx-auto mb-8"
        />

        <p className="text-gray-600 max-w-2xl mx-auto mb-10">
          Recognized globally and throughout the Noida as a Top Impact Company,
          we are renowned for our outstanding IT services and Virtual Staffing commitment to
          excellence.
        </p>
      </motion.div>

      {/* Badges */}
<motion.div
  className="flex justify-center items-center flex-wrap gap-6" // Added flex, justify-center, items-center, flex-wrap
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
  variants={fadeUp}
>
  {badges.map((badge, index) => (
    <motion.img
      key={index}
      src={badge.src}
      alt={badge.alt}
      className="w-28 sm:w-32 hover:scale-105 transition-transform duration-300"
      whileHover={{ scale: 1.1 }}
    />
  ))}
</motion.div>
    </section>
  );
}
